import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ErrorStateWithReload from '../../../components/ErrorStateWithReload';
import MarketReportsTable from '../components/market-reports/MarketReportsTable';
import Container from '../../../components/Container';

import { fetchMarketReports } from '../actions';
import {
  marketReportsSettingsSelector,
  marketReportsFiltersSelector,
  marketReportsSelector,
} from '../selectors';

const MarketReports = () => {
  const dispatch = useDispatch();

  const settings = useSelector(marketReportsSettingsSelector);
  const filters = useSelector(marketReportsFiltersSelector);
  const reports = useSelector(marketReportsSelector);

  const handleFiltersChange = useCallback((params) => {
    dispatch(fetchMarketReports(params));
  }, []);

  useEffect(() => {
    if (!reports.length) {
      dispatch(fetchMarketReports());
    }
  }, []);

  return (
    <div className="market-reports">
      <Container gutters={32}>
        {settings.error && <ErrorStateWithReload />}
        <MarketReportsTable
          filters={filters}
          tableData={reports}
          isLoading={settings.pending}
          onFiltersChange={handleFiltersChange}
        />
      </Container>
    </div>
  );
};

export default MarketReports;
